import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  Show,
  SimpleShowLayout,
  DisabledInput,
  ReferenceInput,
  SelectInput,
  translate as t,
  DeleteButton,
  RefreshButton,
} from 'admin-on-rest';
import queryString from 'query-string';
import { FlatButton, CardActions } from 'material-ui';

import { Link } from 'react-router-dom';
import { has } from 'lodash';

import TextArrayInput from '../components/inputs/TextArrayInput';
import PageReferenceFilter from '../components/PageReferenceFilter';
import SlugLink from '../components/button/SlugLink';
import lStorage from '../utils/localStorage';
import Delete from '../components/Overrides/mui/delete/Delete';

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

export const QuestionList = (props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="question" />
    </Datagrid>
  </List>
);

const QuestionTitle = ({ record }) => (
  <span>{record ? `${record.question}` : ''}</span>
);

const QuestionCreateActions = () => (
  <CardActions style={cardActionStyle}>
  </CardActions>
);

const QuestionEditActions = ({ basePath, data }) => (
  <CardActions style={cardActionStyle}>
    <DeleteButton basePath={basePath} record={data} />
    <RefreshButton />
  </CardActions>
);

export const QuestionDelete = (props) => (
  <Delete {...props} redirect={lStorage.string.load('lastParent')} /> // the parent can be chapter or course
);

const AcademyCreateUI = (props) => (
  <Create {...props} actions={<QuestionCreateActions />}>
    <SimpleForm defaultValue={props.values} {...props} redirect={lStorage.string.load('lastParent')}>
      <Link to="/books">
        <FlatButton primary>{props.translate('home')}</FlatButton>
      </Link>
      <Link to={`/chapters/${props.values.chapterId}`}>
        <FlatButton primary>{props.values.chapterName}</FlatButton>
      </Link>

      <ReferenceInput {...props} label={props.translate('academy.book')} source="bookId" reference="books" allowEmpty>
        <SelectInput defaultValue={props.values.bookName} optionText="title" />
      </ReferenceInput>
      <PageReferenceFilter source="chapterId" label={props.translate('academy.chapter')} addField />

      <TextInput options={{ fullWidth: true }} source="question" label={props.translate('academy.question')} />
      <TextInput options={{ fullWidth: true }} source="correctMessage" label={props.translate('academy.correctMessage')} />
      <TextInput options={{ fullWidth: true }} source="incorrectMessage" label={props.translate('academy.incorrectMessage')} />

      <TextArrayInput source="choices" label={props.translate('option')} />
    </SimpleForm>
  </Create>
);

const CourseCreateUI = (props) => (
  <Create {...props}>
    <SimpleForm defaultValue={props.values} redirect={lStorage.string.load('lastParent')} {...props}>
      <ReferenceInput {...props} label={props.translate('academy.course')} source="courseId" reference="courses" allowEmpty>
        <SelectInput defaultValue={props.values.courseName} optionText="title" />
      </ReferenceInput>

      <TextInput options={{ fullWidth: true }} source="question" label={props.translate('academy.question')} />
      <TextInput options={{ fullWidth: true }} source="correctMessage" label={props.translate('academy.correctMessage')} />
      <TextInput options={{ fullWidth: true }} source="incorrectMessage" label={props.translate('academy.incorrectMessage')} />
      <TextArrayInput source="choices" label={props.translate('option')} />
    </SimpleForm>
  </Create>
);

export const QuestionCreate = t((props) => {
  // const { chapterId, chapterName } = queryString.parse(props.location.search);
  const values = queryString.parse(props.location.search);
  return (
    <div>
      {
        has(values, 'chapterId') ? <AcademyCreateUI {...props} values={values} /> : <CourseCreateUI {...props} values={values} />
      }
    </div>
  );
});

const AcademyEditUI = (props) => (
  <Edit actions={<QuestionEditActions />} {...props}>
    <SimpleForm redirect="edit" {...props}>
      <Link to="/books">
        <FlatButton primary>{props.translate('home')}</FlatButton>
      </Link>
      <SlugLink id="book._id" title="book.title" slug="books" />
      <SlugLink id="chapter._id" title="chapter.title" slug="chapters" />

      <DisabledInput label={props.translate('academy.book')} source="book.title" />
      <DisabledInput label={props.translate('academy.chapter')} source="chapter.title" />

      <TextInput options={{ fullWidth: true }} source="question" label={props.translate('academy.question')} />
      <TextInput options={{ fullWidth: true }} source="correctMessage" label={props.translate('academy.correctMessage')} />
      <TextInput options={{ fullWidth: true }} source="incorrectMessage" label={props.translate('academy.incorrectMessage')} />
      <TextArrayInput source="choices" label={props.translate('option')} />

    </SimpleForm>
  </Edit>
);

const CourseEditUI = (props) => (
  <Edit actions={<QuestionEditActions {...props} />} title={<QuestionTitle />} {...props}>
    <SimpleForm redirect="edit" {...props}>
      <DisabledInput label={props.translate('academy.course')} source="course.title" />

      <TextInput options={{ fullWidth: true }} source="question" label={props.translate('academy.question')} />
      <TextInput options={{ fullWidth: true }} source="correctMessage" label={props.translate('academy.correctMessage')} />
      <TextInput options={{ fullWidth: true }} source="incorrectMessage" label={props.translate('academy.incorrectMessage')} />
      <TextArrayInput source="choices" label={props.translate('option')} />
    </SimpleForm>
  </Edit>
);

const EditComponent = (props) => {
  props.location.state ? lStorage.string.save('lastParent', props.location.state.prevPath) : lStorage.string.save('lastParent', '/books'); // eslint-disable-line

  if (has(props, 'bookId')) {
    return <AcademyEditUI {...props} />;
  }
  return <CourseEditUI {...props} />;
};


export const QuestionEdit = t((props) => (
  <EditComponent {...props} />
  /* <SimpleForm redirect="edit">
    <Link to="/books" >
      <FlatButton primary>{props.translate('home')}</FlatButton>
    </Link>
    <SlugLink id="book._id" title="book.title" slug="books" />
    <SlugLink id="chapter._id" title="chapter.title" slug="chapters" />

    <DisabledInput label={props.translate('academy.book')} source="book.title" />
    <DisabledInput label={props.translate('academy.chapter')} source="chapter.title" />
    <DisabledInput label={props.translate('academy.course')} source="course.title" />

    <TextInput source="question" label={props.translate('academy.question')} />
    <TextArrayInput source="choices" label={props.translate('option')} />

  </SimpleForm> */

));

export const QuestionShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="question" />
    </SimpleShowLayout>
  </Show>
);
